/**
 * Rende cliccabili le card multicolumn
 * Quando si clicca sulla card, si viene reindirizzati al link presente nel tag <a class="link animate-arrow">
 */
document.addEventListener('DOMContentLoaded', function () {
    // Seleziona tutte le card multicolumn
    const cards = document.querySelectorAll('.multicolumn-list__item');


    cards.forEach(card => {
        // Trova il link all'interno della card
        const link = card.querySelector('a.link.animate-arrow');


        // Se esiste un link e ha un href valido
        if (link && link.href && !link.hasAttribute('aria-disabled')) {
            // Aggiungi stile cursor pointer alla card
            card.style.cursor = 'pointer';

            // Aggiungi evento click alla card
            card.addEventListener('click', function (e) {

                // Previeni il comportamento di default solo se non si sta cliccando direttamente sul link
                if (e.target.closest('a.link.animate-arrow') === link) {
                    // Se si clicca direttamente sul link, lascia che funzioni normalmente
                    return;
                }

                // Altrimenti, naviga verso l'URL del link
                window.location.href = link.href;
            });

            // Aggiungi effetto hover (opzionale)
            card.addEventListener('mouseenter', function () {
                card.style.transition = 'transform 0.2s ease';
                card.style.transform = 'translateY(-2px)';
            });

            card.addEventListener('mouseleave', function () {
                card.style.transform = 'translateY(0)';
            });
        }
    });
});
